export const ORGANIZATION_MASTERS = [
  {
    label: "Global Business Regions",
    value: "business-regions",
    hasParent: false,
  },

  {
    label: "Countries",
    value: "countries",
    hasParent: true,
    parent: "business-regions",
  },

  {
    label: "States / Provinces",
    value: "states",
    hasParent: true,
    parent: "countries",
  },

  {
    label: "Districts",
    value: "districts",
    hasParent: true,
    parent: "states",
  },

  {
    label: "Cities / Towns",
    value: "cities",
    hasParent: true,
    parent: "districts",
  },

  {
    label: "Zones",
    value: "zones",
    hasParent: true,
    parent: "cities",
  },

  {
    label: "Areas / Localities",
    value: "areas",
    hasParent: true,
    parent: "zones",
  },

  {
    label: "Beats",
    value: "beats",
    hasParent: true,
    parent: "areas",
  },

  {
    label: "Territories",
    value: "territories",
    hasParent: true,
    parent: "beats",
  },

  {
    label: "Headquarters",
    value: "headquarters",
    hasParent: true,
    parent: "cities",
  },

  {
    label: "Working Stations",
    value: "working-stations",
    hasParent: true,
    parent: "cities",
  },

  {
    label: "Stay Points",
    value: "stay-points",
    hasParent: true,
    parent: "cities",
  },
];